import { mapRecordFromServer, mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, IRequestPayload } from 'coreOld/types';
import { getFormData, getQueryString, objectKeysCamelToSnakeCase } from 'coreOld/utils';
import { ICost } from 'partsOld/types';

export const getMany = async (
  requestPayload?: IRequestPayload
): Promise<GetManyResponse<ICost>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/parts/part-costs?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`
  );

  return mapRecordsFromServer<ICost>(data.data, data.recordsFiltered);
};

export const upsertCost = async (data) => {
  const formData = getFormData({
    corporate_part_cost: objectKeysCamelToSnakeCase(data),
  });

  return partfinitiClient.post(`/corporate/parts/save-cost`, formData);
};

export const getActiveOverlappingCost = async (queryParams) => {
  const { data } = await partfinitiClient.get(
    `/corporate/parts/get-active-overlapping-cost?${getQueryString(
      objectKeysCamelToSnakeCase(queryParams)
    )}`
  );

  return mapRecordFromServer<ICost>(data.corporate_part_cost);
};

export const removeCost = async (data) => {
  const formData = getFormData(objectKeysCamelToSnakeCase(data));

  return partfinitiClient.post(`/corporate/parts/remove-cost`, formData);
};
